import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  RestTargetWebSiteListRequest,
  TargetWebSiteDetailBean,
  TargetWebSiteDetailSearchCriteria,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";

class TargetWebSiteDetailListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };

  opentypeforms = () => {
    this.props.opentypeforms();
  };
  editWebSite = (e, code, webExportTypCode, description) => {
    if (e.detail === 1)
      this.props.editWebSite(code, webExportTypCode, description);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };

  render() {
    let WebSite_list = this.props.WebSite_list;
    let targetWebsiteData = this.props.targetWebsiteData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">Website</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                enterKeyEventHandler={this.enterKeyEventHandler}
                type="text"
                name="code"
                onChange={this.onChange}
                value={targetWebsiteData.code}
                style={{ "text-transform": "uppercase" }}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "webExportTypCode")
                  }
                >
                  WebExportTypeCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "webExportTypCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "originalOrderSource")
                  }
                >
                  originalOrderSource
                  {this.props.order === "desc" &&
                  this.props.sortField === "originalOrderSource" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {WebSite_list.map((Info, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.editWebSite(
                          e,
                          Info.code,
                          Info.webExportTypCode,
                          Info.description
                        )
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.webExportTypCode}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.originalOrderSource}</td>
                  <td>{Info.isActive}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {WebSite_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class WebSiteEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onWebChange = (e) => {
    this.props.onWebChange(e);
  };
  webEnterKeyEvent = (e) => {
    this.props.webEnterKeyEvent(e);
  };
  displayAutoCompleteWebList = () => {
    this.props.displayAutoCompleteWebList();
  };

  render() {
    let targetWebsiteData = this.props.targetWebsiteData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              type="text"
              name="companyCode"
              onChange={this.onChange}
              value={targetWebsiteData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>TargetWebsite Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter Website Code"
              disabled={isDisableFields}
              onChange={this.onChange}
              value={targetWebsiteData.code}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Website Name"
              onChange={this.onChange}
              value={targetWebsiteData.description}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>WebSiteType Code</FormLabel>{" "}
          </Col>
          {
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onWebChange}
                name="webExportTypCode"
                value={targetWebsiteData.webExportTypCode}
                lookupRequired={true}
                lookupHandler={this.props.webExportTypeLookupHandler}
                enterKeyEventHandler={this.webEnterKeyEvent}
                autoCompleteListData={this.props.webPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteWebList}
                showAutoCompleteList={this.props.showAutoCompleteWebList}
                style={{ "text-transform": "uppercase" }}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
          }
          <Col sm="1">
            {" "}
            <FormLabel>Orginal Order Source</FormLabel>{" "}
          </Col>
          {
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onChange}
                disabled={isDisableFields}
                name="originalOrderSource"
                value={targetWebsiteData.originalOrderSource}
                isMandatory={true}
              />
            </Col>
          }
          <Col sm="1">
            <FormLabel>is Active</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={targetWebsiteData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class WebSiteList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      WebSite_list: [],
      response: {},
      pageTitle: "TargetWebsite",
      targetWebsiteData: new TargetWebSiteDetailBean(),
      pageList: new PageListBean(),
      criteria: new TargetWebSiteDetailSearchCriteria(),
      webExportTypes: [],
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isWebsiteListFormOpen: true,
      isWebsiteEntryFormOpen: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowCode: false,
      isShowLookup: true,
      isShowExitButton: true,
      isDisableFields: false,
      showAutoCompleteWebList: false,
      webPageListForAutoCompleteList: new Array(),
      webExportTypeLookupHandler: null,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    let targetWebsiteData = new TargetWebSiteDetailBean();
    targetWebsiteData.companyCode = this.companyCode;
    this.setState({ targetWebsiteData: targetWebsiteData });
    this.loadCacheDetails();
    this.loadPage(1);
    this.cleardata();
    this.initLookupHandlers();
  }
  loadCacheDetails = () => {
    const attribute_cache = { ...this.cache };

    const webExportTypes = new Array();
    if (!isEmptyArray(attribute_cache.webExportTypes))
      webExportTypes.push(...attribute_cache.webExportTypes);
    this.state.webExportTypes = webExportTypes;
  };
  moduleCaption = "TargetWebsite";

  initLookupHandlers = () => {
    let webExportTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.webExportTypes,
      "Web Export Types"
    );
    this.setState({ webExportTypeLookupHandler: webExportTypeLookupHandler });
  };

  onChange = (e) => {
    let targetWebsiteData = this.state.targetWebsiteData;
    targetWebsiteData[e.target.name] = e.target.value;
    this.setState({ targetWebsiteData: targetWebsiteData });
  };

  cleardata = () => {
    let targetWebsiteData = new TargetWebSiteDetailBean();
    targetWebsiteData.companyCode = this.companyCode;
    this.setState({ targetWebsiteData: targetWebsiteData });
  };

  saveTargetWebsiteResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeWebsiteEntryForm();
  };
  validateTargetWebsiteData = (targetWebsiteData) => {
    let isTargetWebsiteData = false;
    let err_list = [];
    let errorMessage = "";
    if (targetWebsiteData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(targetWebsiteData.description)) {
        let errMsg = "TargetWebsite Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(targetWebsiteData.code)) {
        let errMsg = "TargetWebsite Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(targetWebsiteData.webExportTypCode)) {
        let errMsg = "webExportTypCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isTargetWebsiteData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isTargetWebsiteData = true;
      this.setState({ isShowAlert: false });
    }
    return isTargetWebsiteData;
  };
  saveWebsite = () => {
    let targetWebsiteData = this.state.targetWebsiteData;
    let isValidLine = false;
    isValidLine = this.validateTargetWebsiteData(targetWebsiteData);
    if (isValidLine) {
      if (targetWebsiteData.isFetched == true) {
        if (SecurityAccessManager.targetWebsiteDetailsEdit_isAccessible()) {
          MasterService.updateTargetWebSiteDetail(
            targetWebsiteData,
            this.saveTargetWebsiteResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.targetWebsiteDetailsCreate_isAccessible()) {
          MasterService.createTargetWebSiteDetail(
            targetWebsiteData,
            this.saveTargetWebsiteResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = " Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editTargetWebsiteResponse = (response) => {
    if (response.data != null) {
      if (response.data.targetWebsiteDetail != null) {
        let targetWebsiteData = response.data.targetWebsiteDetail;
        this.setState({
          targetWebsiteData: targetWebsiteData,
        });
        this.disable();
      }
      this.openWebSiteEntryForm();
    }
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = () => {
    let targetWebsiteData = this.state.targetWebsiteData;
    this.editWebSite(
      targetWebsiteData.code,
      targetWebsiteData.webExportTypCode,
      targetWebsiteData.description
    );
  };

  editWebSite = (code, webExportTypCode, description) => {
    let readrestInput = new TargetWebSiteDetailSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    readrestInput.webExportTypeCode = webExportTypCode;
    readrestInput.name = description;
    if (SecurityAccessManager.targetWebsiteDetailsView_isAccessible()) {
      MasterService.readTargetWebSiteDetail(
        readrestInput,
        this.editTargetWebsiteResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    this.saveWebsite();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeWebsiteEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openWebSiteEntryForm = () => {
    this.setState({
      isWebsiteListFormOpen: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      isWebsiteEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isShowAlert: false,
    });
    this.hideAlertCallBack();
  };

  closeWebsiteEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isWebsiteListFormOpen: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      isWebsiteEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowCode: false,
      isShowLookup: true,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new TargetWebSiteDetailSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadWebsitePage(pageInput, criteria);
  };

  loadWebsiteResponse = (response) => {
    if (response.data != null && response.data.webSitePageList != null) {
      let websiteDetails = new Array();
      if (!isEmptyArray(response.data.webSitePageList.websiteDetails)) {
        websiteDetails = response.data.webSitePageList.websiteDetails;
        websiteDetails.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.webSitePageList.totalCount;
      pageList.currentPage = response.data.webSitePageList.currentPage;
      pageList.pageSize = response.data.webSitePageList.pageSize;
      this.setState({
        WebSite_list: websiteDetails,
        pageList: pageList,
      });
    }
  };

  loadWebsitePage = (pageList, criteria) => {
    let requestInput = new RestTargetWebSiteListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.targetWebsiteDetailsView_isAccessible()) {
      MasterService.getTargetWebSiteDetailsPageList(
        requestInput,
        this.loadWebsiteResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };

  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  onWebChange = (e) => {
    let webExportTypCode = e.target.value;
    this.state.showAutoCompleteWebList = true;
    let temp_data = this.state.targetWebsiteData;
    let showAutoCompleteList = this.state.showAutoCompleteWebList;
    if (isEmpty(webExportTypCode)) {
      this.state.showAutoCompleteWebList = false;
      let showAutoCompleteList = this.state.showAutoCompleteWebList;
      let soLine = this.state.targetWebsiteData;
      soLine.webExportTypCode = "";
      soLine.fromCurrencyName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        targetWebsiteData: soLine,
        webPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && webExportTypCode !== "") {
      this.readWebBySearchString(webExportTypCode);
    }
    if (e.target.name == "webExportTypCode") {
      temp_data["webExportTypCode"] = e.target.value;
      let webExportData = this.state.webExportTypes;
      webExportData.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_data["webExportTypCode"] = pdtType.code;
          this.state.showAutoCompleteWebList = false;
          let showAutoCompleteList = this.state.showAutoCompleteWebList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ targetWebsiteData: temp_data });
  };
  readWebBySearchString(searchString) {
    let webExportData = this.state.webExportTypes;
    let simpleAutoCompleteList = new Array();
    if (webExportData.length > 0 && webExportData != null) {
      webExportData.map((datas) => {
        let simpleItemBean = {
          code: datas.code,
          description: datas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      webPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  webEnterKeyEvent = (e) => {
    let temp_data = this.state.targetWebsiteData;
    temp_data["webExportTypCode"] = e.target.value;
    let webExportData = this.state.webExportTypes;
    let webExpotBean = null;
    webExportData.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        webExpotBean = pdtType;
      }
    });
    if (!isEmpty(webExpotBean)) {
      let temp_data = this.state.targetWebsiteData;
      temp_data.webExportTypCode = webExpotBean.code;
      temp_data.fromCurrencyName = webExpotBean.description;
      this.setState({
        targetWebsiteData: temp_data,
        webPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteWebList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteWebList: showAutoCompleteList });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.WebSite_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ WebSite_list: sorted });
    }
  };

  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isWebsiteListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}
        {!this.state.isWebsiteListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}

        {this.state.isWebsiteListFormOpen && (
          <TargetWebSiteDetailListForm
            {...this.state}
            onChange={this.onChange}
            editWebSite={this.editWebSite}
            enterKeyEventHandler={this.enterKeyEventHandler}
            opentypeforms={this.opentypeforms}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isWebsiteEntryFormOpen && (
          <WebSiteEntryForm
            {...this.state}
            onChange={this.onChange}
            webEnterKeyEvent={this.webEnterKeyEvent}
            onWebChange={this.onWebChange}
            displayAutoCompleteWebList={this.displayAutoCompleteWebList}
          />
        )}
      </div>
    );
  }
}

function TargetWebSiteDetailAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <WebSiteList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default TargetWebSiteDetailAttributeModule;
